import { createContext, useState } from "react";
interface ISearchedValues {
  keyword?: string;
  radius?: string;
  category?: string;
  zip?: string;
  region?: string;
}
interface ISearchedValuesContext {
  searchedAuctionsValues: ISearchedValues;
  setSearchedAuctionsValues: (values: ISearchedValues) => void;
}
const IParamsDefaultValues = {
  searchedAuctionsValues: {
    keyword: "",
    radius: "",
    category: "",
    zip: "",
    region: "",
  },
  setSearchedAuctionsValues: () => {},
};
export const SeachedAuctionParamsContext =
  createContext<ISearchedValuesContext>(IParamsDefaultValues);
export const SearchedAuctionParamsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [searchedAuctionsValues, setSearchedAuctionsValues] =
    useState<ISearchedValues>({
      category: "",
      keyword: "",
      radius: "",
      zip: "",
      region: "",
    });
  return (
    <SeachedAuctionParamsContext.Provider
      value={{
        searchedAuctionsValues,
        setSearchedAuctionsValues: (values) =>
          setSearchedAuctionsValues(values),
      }}
    >
      {children}
    </SeachedAuctionParamsContext.Provider>
  );
};
